__turbopack_context__.v({
  "extra": "DeskReadout-module__0utMqq__extra",
  "gain": "DeskReadout-module__0utMqq__gain",
  "hint": "DeskReadout-module__0utMqq__hint",
  "label": "DeskReadout-module__0utMqq__label",
  "lead": "DeskReadout-module__0utMqq__lead",
  "loss": "DeskReadout-module__0utMqq__loss",
  "quiet": "DeskReadout-module__0utMqq__quiet",
  "readout": "DeskReadout-module__0utMqq__readout",
  "row": "DeskReadout-module__0utMqq__row",
  "rowItem": "DeskReadout-module__0utMqq__rowItem",
  "value": "DeskReadout-module__0utMqq__value",
});
